/// <reference path="../../../../../../typings/index.d.ts" />
/// <reference path="../../controls.module.ts" />
///<reference path="../../../../plugins/reports/reports.models.ts"/>
///<reference path="../../../../components/models/meevo.model.custom.ts"/>


module Meevo.Components.Controls {

    import Dictionary = _.Dictionary;
    import IReportControlCriteria = Meevo.Plugins.Reports.IReportControlCriteria;
    import IReportControlScope = Meevo.Plugins.Reports.IReportControlScope;

    export class Ma045Criteria implements IReportControlCriteria {

        public criteria: Dictionary<any>;

        constructor(private scope: IReportControlScope) {
            this.criteria = {
                DepartmentId: null
            };

            scope.mainModel[this.scope.parameterNames[0]] = null;

            scope.$watch(
                () => scope.mainModel[this.scope.parameterNames[0]],
                _.debounce(this.updateCriteria.bind(this), 200),
                true
            );
        }

        private updateCriteria(newValue: string, oldValue: string) {
            if (newValue === oldValue) return;

            angular.extend(this.criteria, {
                DepartmentId: this.scope.mainModel[this.scope.parameterNames[0]]
            });

            this.scope.$apply();
        }
    }

}
